import { render, staticRenderFns } from "./notification-IssueCommentMention.vue?vue&type=template&id=6f4eddeb&scoped=true"
import script from "./notification-IssueCommentMention.vue?vue&type=script&lang=js"
export * from "./notification-IssueCommentMention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4eddeb",
  null
  
)

export default component.exports